import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IrisIconComponent, IconSizes } from '@sondermind/iris/icon';

import { SegmentPreviewService } from '../../services/segment-preview.service';
import { DevToolsHomeComponent } from '../dev-tools-home/dev-tools-home.component';
import { SegmentPreviewToolComponent } from '../segment-preview-tool/segment-preview-tool.component';
import { AmplitudeFlagToolComponent } from '../amplitude-flag-tool/amplitude-flag-tool.component';

type DevToolsView = 'home' | 'segment-preview' | 'amplitude-flags';

@Component({
  selector: 'dev-tools-panel',
  standalone: true,
  imports: [
    CommonModule,
    IrisIconComponent,
    DevToolsHomeComponent,
    SegmentPreviewToolComponent,
    AmplitudeFlagToolComponent
  ],
  templateUrl: './dev-tools-panel.component.html',
  styleUrl: './dev-tools-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevToolsPanelComponent {
  readonly iconSizes = IconSizes;
  readonly currentView = signal<DevToolsView>('home');
  readonly expanded = signal(false);

  constructor(public previewService: SegmentPreviewService) {}

  navigateToTool(toolId: string): void {
    this.currentView.set(toolId as DevToolsView);
  }

  navigateToHome(): void {
    this.currentView.set('home');
  }

  toggleExpanded(): void {
    this.expanded.update((v) => !v);
  }

  closePanel(): void {
    this.previewService.closePanel();
    // Reset to home screen when closing
    this.currentView.set('home');
  }
}
